// Keeps the language of the FormKit validation messages in sync with the website language
export default defineNuxtPlugin((nuxtApp) => {
  const formkit = nuxtApp.vueApp.config.globalProperties.$formkit;
  const { locale } = nuxtApp.$i18n as { locale: Ref<string> };

  watch(locale, (newLocale) => formkit?.setLocale(newLocale), { immediate: true });
});
